import {create} from 'zustand';

/**
 * In-memory UI state for the Sources Upload Queue panel.
 *
 * Kept separate from the queue data store (`useSourcesUploadQueueStore`) so the panel
 * presentation state is self-contained and easy to test.
 *
 *  - `collapsed`: queue starts collapsed (closed) by default; toggled by the chevron.
 *  - `dismissed`: user explicitly closed the queue panel.
 */
const useSourcesUploadQueueUiStore = create(
    (set) => ({
        collapsed: true,
        dismissed: false,
        setCollapsed: (collapsed) => set({collapsed}),
        toggleCollapsed: () => set((state) => ({collapsed: !state.collapsed})),
        setDismissed: (dismissed) => set({dismissed}),
    })
);

export default useSourcesUploadQueueUiStore;
